export default {
  state: {
    CNSTrack1: false,
    CNSTitle: '',
    initAirportPickup: '',
    quotationloading: false,
    bookingType: '',
    timezones: [],
    venue: {
      show: false,
      list: [],
      lastCoords: '',
      origPickupData: {},
      selected: {
        service: '',
        zone: '',
        location: ''
      }
    },
    quoteLegLoading: {
      leg1: false,
      leg2: false
    }
  },
  mutations: {
    setOtherData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    setInitAirportPickup (state, val) {
      state.initAirportPickup = val
    },
    setQuoteLoading (state, val) {
      state.quotationloading = val
    },
    addTimezone (state, val) {
      state.timezones.push(val)
    },
    setVenueData (state, data) {
      for (let field in data) {
        state.venue[field] = data[field]
      }
    },
    addVenueList (state, data) {
      state.venue.list.push(data)
    },
    setQuoteLegLoadingData (state, data) {
      for (let field in data) {
        state.quoteLegLoading[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/others.js